import React from "react";
import EntityForm from "../CRUD/EntityForm/EntityForm";
import asBookingEngineEntity from "../CRUD/Common/BookingEngineEntityHOC";
import constants from "../CRUD/constants";
import { entityToFormValuesMapper } from "../Common/utils";
import { BASE_URL } from "../request";

import ContainerCM from "./ContainerCM";

import { LoyaltyAllBrandProvider } from "../../../components/loyalty-all-brand-provider";
import { HttpClient } from "../../../lib/http";
import { regenPropertyCache } from "../../common/api";

const BackButton = () => {
  return null;
};

function customEntityToFormValuesMapper({ entity, fields, locales, translationConfig }) {
  const formValues = entityToFormValuesMapper({
    entity,
    fields,
    locales,
    translationConfig,
  });
  const customDomain = entity.customDomain && entity.customDomain.split("://");

  const configurationValues = {
    showBatchCancellation: entity.showBatchCancellation === "1",
    showPackagesManager: entity.showPackagesManager === "1",
    showNewBookingForm: entity.showNewBookingForm === "1",
    useCustomEmailTemplate: entity.useCustomEmailTemplate === "1",
    showEmailTemplateManager: entity.showEmailTemplateManager === "1",
    showDisplayManager: entity.showDisplayManager === "1",
    showAdvancedConditionsManagers: entity.showAdvancedConditionsManagers === "1",
    showAdvancedMealplanManagers: entity.showAdvancedMealplanManagers === "1",
    showPromotionsManager: entity.showPromotionsManager === "1",
    showServicesManager: entity.showServicesManager === "1",
    numberOfPromotionsGroup: entity.numberOfPromotionsGroup,
    showFiltersManager: entity.showFiltersManager === "1",
    hasOneRateChild: entity.hasOneRateChild === "1",
    useCustomChildConfiguration: entity.useCustomChildConfiguration === "true",
    roomStaysAsOtaReservations: entity.roomStaysAsOtaReservations === "1",
    compoundDiscounts: entity.compoundDiscounts === "1",
    hasPremiumMap: entity.hasPremiumMap === "1",
    pedircodigoseguridad: entity.pedircodigoseguridad === "1",
    showOccupationAlternativesManager: entity.showOccupationAlternativesManager === "1",
    stickyBookingForm: entity.stickyBookingForm === "1",
    hideInventoriesFilteredByOccupation:
      entity.showOccupationAlternativesManager === "1"
        ? "0"
        : entity.hideInventoriesFilteredByOccupation,
    showMultipleAccommodations: entity.showMultipleAccommodations === "1",
    maxAccommodationsMultiReservation: entity.maxAccommodationsMultiReservation,
    flexmyroomPropertySecret: entity.flexmyroomPropertySecret,
    fideltourIntegrationCode: entity.fideltourIntegrationCode,
    mailSenderAddress: entity.mailSenderAddress,
    flexmyroomEstablishmentId: entity.flexmyroomEstablishmentId,
    showAccommodationsManager: entity.showAccommodationsManager === "1",
    showAdvancedEmailsManager: entity.showAdvancedEmailsManager === "1",
    newEmailConfig: entity.newEmailConfig === "1",
    showNewReservationModification: entity.showNewReservationModification === "1",
    showInventoryMultiUpdate: entity.showInventoryMultiUpdate === "1",
    showInventoryTable: entity.showInventoryTable === "1",
    showBatchInventories: entity.showBatchInventories === "1",
    propertyImageLimit: entity.propertyImageLimit,
    showNewReservationsList: entity.showNewReservationsList === "1",
    splitReservationQuantityAsRoomStays: entity.splitReservationQuantityAsRoomStays === "1",
    showCancellationTable: entity.showCancellationTable === "1",
    hasRoomCombinationByLock: entity.hasRoomCombinationByLock === "1",
    externalHotelId: entity.externalHotelId,
    promotionsListMode: entity.promotionsListMode,
    showCookiePolicy: entity.showCookiePolicy === "1",
    reservationIdType: entity.reservationIdType,
    activeAbandonmentCart: entity.activeAbandonmentCart === "1",
    defaultBrand: entity.defaultBrand,
    showHistoricalReservations: entity.showHistoricalReservations === "1",
    detailedExtraInformation: entity.detailedExtraInformation === "1",
    engineVersion: entity.engineVersion,
    v21Status: entity.v21Status,
    hotelverseSubscriptionKey: entity.hotelverseSubscriptionKey,
    hotelverseClientId: entity.hotelverseClientId,
    hotelverseHotelId: entity.hotelverseHotelId,
    hotelVerseActive: entity.hotelVerseActive === "1",
    showEnginePrices: entity.showEnginePrices === undefined || entity.showEnginePrices === "1",
    abTestActive: entity.abTestActive === "1",
    useResilienceReservationStateMachine: entity.useResilienceReservationStateMachine === "true",
    commentsInGlobalInfo: entity.commentsInGlobalInfo === "1",
    isRegenCacheActive: entity.isRegenCacheActive === "1",
    sendCombinedBookingDetailedInfo: entity.sendCombinedBookingDetailedInfo === "1",
    sendFailedChannelNotificationToClient: entity.sendFailedChannelNotificationToClient === "1",
    showEngineDiscount:
      entity.showEngineDiscount === undefined || entity.showEngineDiscount === "1",
    useFullRatesChMg: entity.useFullRatesChMg,
    sendChildInvChMg: entity.sendChildInvChMg === "1",
    strictUpdates: entity.strictUpdates === "1",
    hardcodeTestCreditCardData: entity.hardcodeTestCreditCardData === "1",
    showLoyaltyPromotedDiscount:
      entity.showLoyaltyPromotedDiscount === undefined ||
      entity.showLoyaltyPromotedDiscount === "1",
    enableLoyalty: entity.enableLoyalty === undefined || entity.enableLoyalty === "1",
    showAltARIManagerStyles:
      entity.showAltARIManagerStyles === undefined || entity.showAltARIManagerStyles === "1",
    numberOfDaysARIManager: entity.numberOfDaysARIManager,
  };

  if (customDomain && customDomain[0] && customDomain[1]) {
    configurationValues.customDomainProtocol = customDomain[0];
    configurationValues.customDomain = customDomain[1];
  }

  return {
    ...formValues,
    ...configurationValues,
  };
}

class ConfigurationManager extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      entity: {},
      loading: false,
      entityError: false,
      entityResult: false,
      fields: [],
    };

    this.apiClient = new HttpClient(BASE_URL);
    this.middlewareClient = new HttpClient(props.config.restConfig.baseURL);
  }

  getProperties = () => {
    const { hotelTicker } = this.props;

    const url = `/${this.props.config.restConfig.fetch.url({
      hotelTicker,
    })}`;

    const params = new URLSearchParams();
    params.append("prop", "showNewBookingForm");
    params.append("prop", "stickyBookingForm");
    params.append("prop", "useCustomEmailTemplate");
    params.append("prop", "showEmailTemplateManager");
    params.append("prop", "showDisplayManager");
    params.append("prop", "showAdvancedConditionsManagers");
    params.append("prop", "showAdvancedMealplanManagers");
    params.append("prop", "showPromotionsManager");
    params.append("prop", "numberOfPromotionsGroup");
    params.append("prop", "showServicesManager");
    params.append("prop", "showFiltersManager");
    params.append("prop", "hasOneRateChild");
    params.append("prop", "roomStaysAsOtaReservations");
    params.append("prop", "useCustomChildConfiguration");
    params.append("prop", "useResilienceReservationStateMachine");
    params.append("prop", "compoundDiscounts");
    params.append("prop", "hasPremiumMap");
    params.append("prop", "customDomain");
    params.append("prop", "pedircodigoseguridad");
    params.append("prop", "showOccupationAlternativesManager");
    params.append("prop", "hideInventoriesFilteredByOccupation");
    params.append("prop", "showMultipleAccommodations");
    params.append("prop", "maxAccommodationsMultiReservation");
    params.append("prop", "flexmyroomEstablishmentId");
    params.append("prop", "flexmyroomPropertySecret");
    params.append("prop", "besafeIntegrationUsername");
    params.append("prop", "besafeIntegrationPassword");
    params.append("prop", "mailSenderAddress");
    params.append("prop", "showPackagesManager");
    params.append("prop", "showAccommodationsManager");
    params.append("prop", "showAdvancedEmailsManager");
    params.append("prop", "newEmailConfig");
    params.append("prop", "showNewReservationModification");
    params.append("prop", "showInventoryMultiUpdate");
    params.append("prop", "showInventoryTable");
    params.append("prop", "showNewReservationsList");
    params.append("prop", "splitReservationQuantityAsRoomStays");
    params.append("prop", "showCancellationTable");
    params.append("prop", "promotionsListMode");
    params.append("prop", "showCookiePolicy");
    params.append("prop", "reservationIdType");
    params.append("prop", "hasRoomCombinationByLock");
    params.append("prop", "externalHotelId");
    params.append("prop", "showBatchCancellation");
    params.append("prop", "showBatchInventories");
    params.append("prop", "propertyImageLimit");
    params.append("prop", "activeAbandonmentCart");
    params.append("prop", "defaultBrand");
    params.append("prop", "showHistoricalReservations");
    params.append("prop", "detailedExtraInformation");
    params.append("prop", "engineVersion");
    params.append("prop", "v21Status");
    params.append("prop", "hotelVerseActive");
    params.append("prop", "showEnginePrices");
    params.append("prop", "isRegenCacheActive");
    params.append("prop", "sendCombinedBookingDetailedInfo");
    params.append("prop", "sendFailedChannelNotificationToClient");
    params.append("prop", "hotelverseSubscriptionKey");
    params.append("prop", "hotelverseClientId");
    params.append("prop", "hotelverseHotelId");
    params.append("prop", "abTestActive");
    params.append("prop", "commentsInGlobalInfo");
    params.append("prop", "fideltourIntegrationCode");
    params.append("prop", "showEngineDiscount");
    params.append("prop", "useFullRatesChMg");
    params.append("prop", "sendChildInvChMg");
    params.append("prop", "strictUpdates");
    params.append("prop", "hardcodeTestCreditCardData");
    params.append("prop", "showLoyaltyPromotedDiscount");
    params.append("prop", "enableLoyalty");
    params.append("prop", "showAltARIManagerStyles");
    params.append("prop", "numberOfDaysARIManager");
    params.append("prop", "ulysesCloudClientName");
    params.append("prop", "ulysesCloudProxyClientKey");

    return this.middlewareClient.get(url, { params });
  };

  resetCache = () => {
    const { hotelTicker } = this.props;
    regenPropertyCache(this.apiClient, hotelTicker).then();
  };

  async componentDidMount() {
    try {
      this.setState({ loading: true });
      const properties = await this.getProperties();
      this.setState({ loading: false, entity: properties });
    } catch (e) {
      this.setState({ loading: false, entityError: {} });
    }
  }

  handleSubmit = async ({ formValues }) => {
    delete formValues.undefined;

    const { hotelTicker } = this.props;
    if (formValues.reservationIdType === "AUTO") {
      delete formValues.reservationIdType;
    }
    if (
      formValues.useCustomChildConfiguration !== null &&
      formValues.useCustomChildConfiguration !== undefined
    ) {
      formValues.useCustomChildConfiguration = Boolean(formValues.useCustomChildConfiguration)
        ? "true"
        : "false";
    }
    if (
      formValues.useResilienceReservationStateMachine !== null &&
      formValues.useResilienceReservationStateMachine !== undefined
    ) {
      formValues.useResilienceReservationStateMachine = Boolean(
        formValues.useResilienceReservationStateMachine
      )
        ? "true"
        : "false";
    }
    formValues.customDomain =
      formValues.customDomainProtocol && formValues.customDomain
        ? `${formValues.customDomainProtocol}://${formValues.customDomain}`
        : "";
    delete formValues.customDomainProtocol;

    const url = `/${this.props.config.restConfig.update.url({
      hotelTicker,
    })}`;

    try {
      this.setState({ loading: true, entityResult: false });
      await this.middlewareClient.post(url, formValues);
      const properties = await this.getProperties();
      await this.resetCache();
      this.setState({
        loading: false,
        entityResult: true,
        entity: properties,
        entityError: false,
      });
    } catch (e) {
      console.log("Error");
      console.log(e);
      this.setState({ loading: false, entityError: {} });
    }
  };

  render() {
    const { locales } = this.props;

    const { name, validation, renderers, translation, entities } = this.props.config;

    const { getListPath = () => ({}) } = this.props;

    const { entity, entityError, entityResult, loading } = this.state;

    const { handleSubmit } = this;

    return (
      <LoyaltyAllBrandProvider>
        <ContainerCM
          configFields={this.props.config.fields}
          Component={({ fieldsConfig }) => {
            return (
              <EntityForm
                loading={loading}
                name={name}
                entity={entity}
                entities={entities}
                validation={validation}
                renderers={renderers}
                fields={fieldsConfig?.form || []}
                locales={locales}
                translation={translation}
                onSubmit={handleSubmit}
                entityError={entityError}
                entityResult={entityResult}
                getListPath={getListPath}
                BackButton={BackButton}
                entityToFormValuesMapper={customEntityToFormValuesMapper}
              />
            );
          }}
        />
      </LoyaltyAllBrandProvider>
    );
  }
}

ConfigurationManager.propTypes = {};

ConfigurationManager.defaultProps = {
  locales: ["es", "ca", "en", "fr", "it", "de"],
};

export default asBookingEngineEntity(ConfigurationManager, {
  entityName: constants.ENTITY.CONFIGURATION_MANAGER.name,
  type: "FORM",
});
